export const ReportedTypeEnum = {
  LEASE_AGREEMENT: 'LEASE_AGREEMENT',
  LEASE_ADDENDUM: 'LEASE_ADDENDUM',
  CONDITION_REPORT: 'CONDITION_REPORT',
  FORMS: 'FORMS',
  OTHER: 'OTHER',
};
